import {BooleanField, Datagrid, FunctionField, ListProps, TextField, TextInput} from "react-admin";
import {getDefaultListProps, initField, initInput} from "../shared/utils";
import {CustomList} from "../components/CustomList";
import {useOptionsResource} from "../shared/hooks/useOptionsResource";
import {IdentifierField} from "../components/IdentifierField";
import {EmployeeField} from "../components/EmployeeField";
import {EmployeePhotoFromBase64} from "../components/EmployeePhotoFromBase64";
import {CellChangePassword} from "./CellChangePassword";


export const UsersList = (props: ListProps) => {
    const { data: options } = useOptionsResource("GET");

    const filters = options ? [
        <TextInput {...initField("username", options)} alwaysOn/>
    ] : [];


    return options ? (
        <CustomList {...getDefaultListProps(props)} filters={filters}>
            <Datagrid>
                <IdentifierField {...initField("id", options)} />
                <TextField {...initField("username", options)} />
                <FunctionField
                    label="Foto"
                    render={(record:any) =>
                        record?.employee_object?.photo_base64 ? (
                            <EmployeePhotoFromBase64 base64img={record.employee_object.photo_base64} checkCondition={record.employee_object}/>
                        ) : null
                }
                />
                <EmployeeField {...initField("employee_object", options)} label="Operatore" />
                <FunctionField label="Cambia password" render={(record:any) => (
                    <CellChangePassword id_user={record.id}/>
                )}/>
                <BooleanField {...initField("is_active", options)}/>
                <FunctionField label="Gruppi" render={(record:any) => record.groups_objects.map((group:any) => group.name).join(", ")} />
            </Datagrid>
        </CustomList>
    ) : null
}